<template>
	<div class="businesses-overview-container">
		<AppCard :title="getString('businesses_map')" class="card-map">
			<template v-slot:body>
				<div class="filters-row">
					<AppSelect :selected-index="0" :values="[getString('registered'), getString('subscribed'), getString('order_and_pay'), getString('pos'), getString('any_plugin')]" @selected="changeMapFilter" />
				</div>
				<MapCluster v-if="isAllowed" :geojson="getJson" />
			</template>
		</AppCard>
	</div>
</template>

<script>

import {useLanguageStore} from "@/shared/stores";
import {useSuperStore} from "@/user/stores";
import {useAnalyticsStore} from "@/console-new/stores";
import {formatDateTime} from "@/shared/helpers/dates";
import AppCard from "@/shared/components/AppCard.vue";
import MapCluster from "@/user/components/overview-businesses/MapCluster.vue";
import AppSelect from "@/shared/components/AppSelect.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const superStore = useSuperStore();
		const analyticsStore = useAnalyticsStore();
		return {formatDateTime, getString: languageStore.getString, superStore, analyticsStore}
	},
	name: "BusinessesOverviewContainer",
	components: {AppSelect, AppCard, MapCluster},
	data() {
		return {
			currentMapFilter: 0,
			getJson: this.createBusinessesCluster(),
		}
	},
	computed: {
		isAllowed() {
			return this.superStore.businesses !== null && this.superStore.businesses.length >= 8;
		}
	},
	methods: {
		changeMapFilter(i) {
			this.currentMapFilter = i;
			this.getJson = this.createBusinessesCluster();
		},
		createBusinessesCluster() {
			let result = {
				"type": "FeatureCollection",
				"features": []
			};
			if(this.superStore.businesses) {
				for(let i = 0; i < this.superStore.businesses.length; i++) {
					let b = this.superStore.businesses[i];
					if(b.address && b.address.lat && b.address.lng) {

						if(this.currentMapFilter === 1) {
							if(!b.plan_id) continue;
						} else if(this.currentMapFilter === 2) {
							if(!b.plan_id || !b.plan_plugin_order_pay) continue;
						} else if(this.currentMapFilter === 3) {
							if(!b.plan_plugin_pos) continue;
						} else if(this.currentMapFilter === 4) {
							if(!b.plan_plugin_pos && (!b.plan_id || (!b.plan_plugin_order_pay && !b.plan_plugin_counter))) continue;
						}

						result.features.push({
							"type": "Feature",
							"properties": {
								"businessId": b.business_id,
								"businessName": b.name,
							},
							"geometry": {
								"type": "Point",
								"coordinates": [b.address.lng, b.address.lat]
							}
						});
					}
				}
			}

			return result;
		},
	},
	mounted() {
		if(!this.isAllowed) {
			this.$router.push("/analytics");
		}
	}
}
</script>

<style scoped lang="scss">
.businesses-overview-container {
	display: flex;
	justify-content: center;
}
.card-map {
	width: 50%;

	@media (max-width: 768px) {
		width: 100%;
	}

	.filters-row {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding-bottom: 12px;
	}
}
</style>